import type { BoardModel } from '../board/BoardModel';
import type { TileStackModel } from '../board/TileStackModel';
import { TileRemovalReason } from '../board/BoardEvents';
import { MeasureTapeBlockerModel } from '../blockers/MeasureTapeBlockerModel';
import type { GameTutorialController } from '../../../tutorials/game/GameTutorialController';

export class BoosterHammerModel {
  public tutorial: GameTutorialController | null = null;

  constructor(private readonly board: BoardModel) {}

  public canExecute(): boolean {
    return !this.board.isBoardEmpty();
  }

  public setTutorialController(tutorial: GameTutorialController | null): void {
    this.tutorial = tutorial;
  }

  public canExecuteOnStack(stack: TileStackModel): boolean {
    if (this.tutorial && !this.tutorial.canUseBoosterOnStack(stack)) return false;
    return !stack.locked && (stack.hasTiles() || !!stack.blocker) && (stack.blocker?.destructible ?? true);
  }

  public execute(stack: TileStackModel): void {
    if (!this.canExecuteOnStack(stack)) return;

    if (stack.blocker instanceof MeasureTapeBlockerModel) {
      stack.blocker.retractAll();
    } else if (stack.blocker) {
      this.board.removeBlocker(stack, stack.blocker);
    } else if (stack.underTileBlocker) {
      this.board.removeBlocker(stack, stack.underTileBlocker);
    }

    this.board.removeTilesFromStack({
      stack,
      tilesAmount: stack.getTileCount(),
      reason: TileRemovalReason.Booster,
    });
  }
}
